import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import {
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  Button,
  Checkbox,
  FormControlLabel,
  DialogActions,
  Box,
} from '@mui/material'

import { TextInput } from '../../../../ui'
import { createEmailException } from '../../slices/email-management.slice'

export const CreateEmailExceptionDialog = ({ close }) => {
  const intl = useIntl()
  const { formatMessage } = intl
  const dispatch = useDispatch()
  const empresa_id = useSelector((state) => state.global['empresa_id'])

  const [formState, setFormState] = useState({
    email: '',
    isInWhitelist: false,
    isInBlacklist: false,
    motive: '',
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleChangeForm = (event) => {
    setFormState({ ...formState, [event.target.name]: event.target.value })
  }

  const handleCheckboxChange = (listType) => (event) => {
    const isChecked = event.target.checked
    setFormState({
      ...formState,
      [listType]: isChecked,
    })
  }

  const handleCreateEmailException = (event) => {
    event.preventDefault()

    if (!formState.email.trim().length) {
      return
    }

    if (!formState.isInWhitelist && !formState.isInBlacklist) {
      return
    }

    const payload = {
      email: formState.email,
      isInWhitelist: formState.isInWhitelist,
      isInBlacklist: formState.isInBlacklist,
      motive: formState.motive || '',
      empresa_id: Number(empresa_id),
    }

    dispatch(createEmailException(payload, setIsLoading, close))
  }

  const isButtonDisabled =
    isLoading || !formState.email.trim() || (!formState.isInWhitelist && !formState.isInBlacklist)

  return (
    <>
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h3" color="primary">
          {formatMessage({ id: `pages.emailManagement.addButton.label` })}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <form id="create-email-exception-form" onSubmit={handleCreateEmailException}>
          <Grid container spacing={2} sx={{ rowGap: 1 }}>
            <Grid size={{ xs: 12, sm: formState.isInBlacklist ? 6 : 12 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 0.5 }}>
                {formatMessage({ id: 'pages.emailManagement.createDialog.emailLabel' })}:
              </Typography>
              <TextInput
                required
                value={formState.email}
                name="email"
                placeholder={formatMessage({
                  id: 'pages.emailManagement.createDialog.emailPlaceholder',
                })}
                onChange={handleChangeForm}
              />
            </Grid>
            {formState.isInBlacklist && (
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 0.5 }}>
                  {formatMessage({ id: 'pages.emailManagement.createDialog.motiveLabel' })}:
                </Typography>
                <TextInput
                  value={formState.motive}
                  name="motive"
                  placeholder={formatMessage({
                    id: 'pages.emailManagement.createDialog.motivePlaceholder',
                  })}
                  onChange={handleChangeForm}
                />
              </Grid>
            )}

            <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                {formatMessage({ id: 'pages.emailManagement.createDialog.selectListsLabel' })}:
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formState.isInWhitelist}
                      onChange={handleCheckboxChange('isInWhitelist')}
                      name="whitelist"
                      color="primary"
                    />
                  }
                  label={formatMessage({ id: 'pages.emailManagement.createDialog.whitelistLabel' })}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formState.isInBlacklist}
                      onChange={handleCheckboxChange('isInBlacklist')}
                      name="blacklist"
                      color="primary"
                    />
                  }
                  label={formatMessage({ id: 'pages.emailManagement.createDialog.blacklistLabel' })}
                />
              </Box>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          type="submit"
          form="create-email-exception-form"
          color="primary"
          variant="contained"
          disabled={isButtonDisabled}
        >
          {formatMessage({ id: 'global.create' })}
        </Button>
      </DialogActions>
    </>
  )
}
